const formatByCountry = {
    NL: {
        ignore: /^CD/i,
        regex: /\d+|\p{Letter}+/giu,
        delimiter: '-'
    },
    DE: {
        ignore: /^(0|1)/,
        regex: /.*/,
        delimiter: ''
    },
    E: {
        ignore: /^(CD|CC|TA|OI)/i,
        regex: /\d+|\p{Letter}+/giu,
        delimiter: ' '
    }
};

const whitespace = /\s+/g;
const cleanup = /[ -]+/g;

export const sanitizeLicensePlate = (value: string) => {
    return value.toUpperCase().replace(whitespace, ' ').trim();
};

export const formatLicensePlate = (value: string, countryCode = 'NL') => {
    const format = formatByCountry[countryCode];
    const sanitized = sanitizeLicensePlate(value);

    // unknown country, return sanitized value
    if (!format) {
        return sanitized;
    }

    // value patterns that should be ignored, like diplomatic plates
    if (format.ignore.test(value)) {
        return sanitized;
    }

    // known format with regular value, try to format
    const { regex, delimiter } = format;
    return regex.test(sanitized) ? sanitized.match(regex).join(delimiter) : sanitized;
};

export const cleanupLicensePlate = (value = '') => {
    return value.replace(cleanup, '');
};
